import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

// react-select `Control` that prepends a leading icon inside the input box.
export const withLeadingIcon = (icon) => {
  const IconControl = ({ children, ...props }) => (
    <components.Control {...props}>
      <span className="tw-flex tw-items-center tw-pl-2.5 tw-text-slate-400">{icon}</span>
      {children}
    </components.Control>
  );
  IconControl.propTypes = { children: PropTypes.node };
  IconControl.displayName = 'SelectIconControl';
  return IconControl;
};

// react-select `Option` that prepends the same icon before each option label.
export const withIconOption = (icon) => {
  const IconOption = ({ children, ...props }) => (
    <components.Option {...props}>
      <span className="tw-flex tw-items-center tw-gap-2">
        <span className="tw-flex tw-items-center tw-shrink-0 tw-text-slate-400">{icon}</span>
        <span className="tw-min-w-0 tw-truncate">{children}</span>
      </span>
    </components.Option>
  );
  IconOption.propTypes = { children: PropTypes.node };
  IconOption.displayName = 'SelectIconOption';
  return IconOption;
};

// Convenience: build both `Control` + `Option` overrides from a single icon so
// the field icon shows in the input box AND next to every option in the menu.
// Usage: <Select components={selectIconComponents(<FaStore size={14} />)} ... />
export const selectIconComponents = (icon) => ({
  Control: withLeadingIcon(icon),
  Option: withIconOption(icon),
});

// Shared react-select `styles` so every select matches the app's form controls
// (tw-text-sm = 14px, compact 34px control) instead of the browser default 16px.
export const reactSelectCompactStyles = {
  control: (base) => ({ ...base, minHeight: '38px', fontSize: '0.875rem' }),
  valueContainer: (base) => ({ ...base, padding: '0 8px' }),
  input: (base) => ({ ...base, margin: 0, padding: 0, fontSize: '0.875rem' }),
  placeholder: (base) => ({ ...base, fontSize: '0.875rem' }),
  singleValue: (base) => ({ ...base, fontSize: '0.875rem' }),
  multiValue: (base) => ({ ...base, fontSize: '0.8125rem' }),
  indicatorsContainer: (base) => ({ ...base, height: '36px' }),
  menu: (base) => ({ ...base, fontSize: '0.875rem', zIndex: 20 }),
  option: (base) => ({ ...base, fontSize: '0.875rem', padding: '6px 10px' }),
  dropdownIndicator: (base) => ({ ...base, padding: '4px' }),
  clearIndicator: (base) => ({ ...base, padding: '4px' }),
};

export default withLeadingIcon;
